export const SINGULAR_CONTENT_TYPE_OUTPUTS = {
    'ARTICLE': 'ARTICLE',
    'IMAGE': 'PHOTO GALLERY',
    'VIDEO': 'VIDEO',
    'EVENT': 'EVENT',
    'SERIES': 'SERIES',
    'PERSON': 'PLAYER',
    'BUNDLE': 'BUNDLE'
  }
  
  export const PLURAL_CONTENT_TYPE_OUTPUTS = {
    'ARTICLE': 'ARTICLES',
    'IMAGE': 'PHOTO GALLERY',
    'VIDEO': 'VIDEOS',
    'EVENT': 'EVENTS',
    'SERIES': 'SERIES',
    'PERSON': window.settings.internalName.includes('pfl') ? 'FIGHTERS' : 'PLAYERS',
    'BUNDLE': 'BUNDLES'
  }

  export const contentTypes = ["IMAGE", "VIDEO", "SERIES", "EVENT", "ARTICLE", "PERSON", "BUNDLE"]